/* ==========================================================================
  KENO GAME CONSTANTS
========================================================================== */
export const KENO_RISK_MODES = {
  CLASSIC: 'CLASSIC',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH'
}

export const KENO_GAME_RISK_LEVEL = [
  {
    label: 'Classic',
    value: 1
  },
  {
    label: 'Low',
    value: 2
  },
  {
    label: 'Medium',
    value: 3
  },
  {
    label: 'High',
    value: 4
  }
]

export const KENO_PAYOUTS = {
  0: {
    CLASSIC: [0],
    LOW: [0],
    MEDIUM: [0],
    HIGH: [0]
  },
  1: {
    CLASSIC: [0, 3.96],
    LOW: [0.7, 1.85],
    MEDIUM: [0.4, 2.75],
    HIGH: [0, 3.96]
  },
  2: {
    CLASSIC: [0, 1.9, 4.5],
    LOW: [0, 2, 3.8],
    MEDIUM: [0, 1.8, 5.1],
    HIGH: [0, 0, 17.1]
  },
  3: {
    CLASSIC: [0, 1, 3.1, 10.4],
    LOW: [0, 1.1, 1.38, 26],
    MEDIUM: [0, 0, 2.8, 50],
    HIGH: [0, 0, 0, 81.5]
  },
  4: {
    CLASSIC: [0, 0.8, 1.8, 5, 22.5],
    LOW: [0, 0, 2.2, 7.9, 90],
    MEDIUM: [0, 0, 1.7, 10, 100],
    HIGH: [0, 0, 0, 10, 259]
  },
  5: {
    CLASSIC: [0, 0.25, 1.4, 4.1, 16.5, 36],
    LOW: [0, 0, 1.5, 4.2, 13, 300],
    MEDIUM: [0, 0, 1.4, 4, 14, 390],
    HIGH: [0, 0, 0, 4.5, 48, 450]
  },
  6: {
    CLASSIC: [0, 0, 1, 3.68, 7, 16.5, 40],
    LOW: [0, 0, 1.1, 2, 6.2, 100, 700],
    MEDIUM: [0, 0, 0, 3, 9, 180, 710],
    HIGH: [0, 0, 0, 0, 11, 350, 710]
  },
  7: {
    CLASSIC: [0, 0, 0.47, 3, 4.5, 14, 31, 60],
    LOW: [0, 0, 1.1, 1.6, 3.5, 15, 225, 700],
    MEDIUM: [0, 0, 0, 2, 7, 30, 400, 800],
    HIGH: [0, 0, 0, 0, 7, 90, 400, 800]
  },
  8: {
    CLASSIC: [0, 0, 0, 2.2, 4, 13, 22, 55, 70],
    LOW: [0, 0, 1.1, 1.5, 2, 5.5, 39, 100, 800],
    MEDIUM: [0, 0, 0, 2, 4, 11, 67, 400, 900],
    HIGH: [0, 0, 0, 0, 5, 20, 270, 600, 900]
  },
  9: {
    CLASSIC: [0, 0, 0, 1.55, 3, 8, 15, 44, 60, 85],
    LOW: [0, 0, 1.1, 1.3, 1.7, 2.5, 7.5, 50, 25, 1000],
    MEDIUM: [0, 0, 0, 2, 2.5, 5, 15, 100, 500, 1000],
    HIGH: [0, 0, 0, 0, 4, 11, 56, 500, 800, 1000]
  },
  10: {
    CLASSIC: [0, 0, 0, 1.4, 2.25, 4.5, 8, 17, 50, 80, 100],
    LOW: [0, 0, 1.1, 1.2, 1.3, 1.8, 3.5, 13, 50, 250, 1000],
    MEDIUM: [0, 0, 0, 1.6, 2, 4, 7, 26, 100, 500, 1000],
    HIGH: [0, 0, 0, 0, 3.5, 8, 13, 63, 500, 800, 1000]
  }
}

export const BET_MODES = {
  MANUAL: 'manual',
  AUTO: 'auto',
  STRATEGY: 'strategy'
}

export const MAX_INCREASED_BY_PERCENTAGE = {
  KENO_AUTO_BET: 100
}

export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const DEFAULT_PAGE_CALLS = 20
export const ANIMATION_TIMEOUT_IN_MS = 150
